import { EmptyState, Table, TableWrap, TBody, TD, TH, THead, TR } from '@/components/ui';
import type { CampaignReport } from '@/lib/types';

/*
 * Every tracked link and its clicks — unique (one per recipient) and total.
 * The URL is truncated in the cell and carried whole on its title. Rows are
 * rendered in the order the server sent them.
 */

type LinkRow = CampaignReport['links'][number];

const TABLE_STYLE = { minWidth: '480px' };

export function LinkClicksTable({ links }: { links: LinkRow[] }) {
  if (links.length === 0) {
    return <EmptyState title="No tracked links" description="No email in this campaign carried a tracked link." />;
  }

  return (
    <TableWrap frozenHeader frozenMaxHeight="min(60vh, 560px)">
      <Table style={TABLE_STYLE} className="table-fixed">
        <caption className="sr-only">Clicks per link</caption>
        <THead>
          <TR>
            <TH scope="col">Link</TH>
            <TH scope="col" numeric className="w-32">
              Unique clicks
            </TH>
            <TH scope="col" numeric className="w-32">
              Total clicks
            </TH>
          </TR>
        </THead>
        <TBody>
          {links.map((link) => (
            <TR key={link.linkId}>
              <TD>
                <span className="block truncate text-fg-secondary" title={link.url}>
                  {link.url}
                </span>
              </TD>
              <TD numeric>{link.uniqueClicks.toLocaleString()}</TD>
              <TD numeric>{link.totalClicks.toLocaleString()}</TD>
            </TR>
          ))}
        </TBody>
      </Table>
    </TableWrap>
  );
}
